var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaKit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "media-kit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.327,
    height: 121,
    viewBox: "0 0 123.327 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M17.91,108.657a10.174,10.174,0,0,1,9.883-10.4,8.73,8.73,0,0,1,5.3,1.615V98.7h6.248v19.987H33.454l-.075-1.434a8.925,8.925,0,0,1-5.586,1.8A10.14,10.14,0,0,1,17.91,108.657Zm15.324,0a4.513,4.513,0,1,0-1.293,3.243A4.538,4.538,0,0,0,33.234,108.657Z",
    transform: "translate(-8.929 -48.986)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M196.468,119.056a8.946,8.946,0,0,1-5.586-1.8l-.07,1.434H184.93V98.7h6.248v1.173a8.725,8.725,0,0,1,5.29-1.615,10.413,10.413,0,0,1,0,20.8Zm-.918-5.807a4.538,4.538,0,1,0-4.518-4.533A4.543,4.543,0,0,0,195.55,113.25Z",
    transform: "translate(-92.201 -48.987)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M86.27,28.656a10.172,10.172,0,0,1,9.888-10.4,8.69,8.69,0,0,1,5.29,1.615V18.688H107.7v20h-5.882l-.07-1.429a8.945,8.945,0,0,1-5.581,1.8A10.148,10.148,0,0,1,86.27,28.656Zm15.324,0A4.513,4.513,0,1,0,100.3,31.9a4.538,4.538,0,0,0,1.293-3.243Z",
    transform: "translate(-43.012 -9.101)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M86.27,192.657a10.175,10.175,0,0,1,9.888-10.4,8.725,8.725,0,0,1,5.29,1.615V182.7H107.7v19.987h-5.882l-.07-1.434a8.915,8.915,0,0,1-5.581,1.815A10.152,10.152,0,0,1,86.27,192.657Zm15.324,0A4.513,4.513,0,1,0,100.3,195.9,4.538,4.538,0,0,0,101.594,192.657Z",
    transform: "translate(-43.012 -90.866)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1453",
    "data-name": "Rectangle 1453",
    width: 60.828,
    height: 60.828,
    transform: "translate(31.41 30.261)",
    fill: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M123.216,88.048H105.164a1,1,0,0,1-.722-1.745l6.96-6.955a7.251,7.251,0,0,1,10.254,0l3.64,3.635a2.963,2.963,0,0,1-2.081,5.064Z",
    transform: "translate(-51.907 -38.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M102.589,143.189h18.051a1,1,0,0,1,.722,1.75l-6.955,6.955a7.256,7.256,0,0,1-10.259,0l-3.64-3.64a2.968,2.968,0,0,1,2.081-5.064Z",
    transform: "translate(-49.678 -71.389)",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M101.1,122.7h30.7c1.344,0,2.006,2.066,1.068,3.274l-3.731,4.733a1.374,1.374,0,0,1-1.068.562H104.835a1.359,1.359,0,0,1-1.068-.562l-3.731-4.733C99.083,124.766,99.755,122.7,101.1,122.7Z",
    transform: "translate(-49.652 -61.175)",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M80.187,107.515l3.9-4.739a1.454,1.454,0,0,1,1.113-.557h24.274a1.459,1.459,0,0,1,1.118.557l3.9,4.738c1,1.208.291,3.269-1.113,3.269H81.285C79.9,110.784,79.194,108.724,80.187,107.515Z",
    transform: "translate(-39.747 -50.964)",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y2: 121,
    transform: "translate(8.665)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    y2: 121,
    transform: "translate(30.908)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    y2: 121,
    transform: "translate(92.233)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x1: 123.327,
    transform: "translate(0 8.835)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x1: 123.327,
    transform: "translate(0 30.261)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x1: 123.327,
    transform: "translate(0 91.09)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 123.327,
    transform: "translate(0 112.516)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y2: 121,
    transform: "translate(114.155)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaKit);
export default __webpack_public_path__ + "static/media/media-kit.c78bc05f81e9100bb4eb9ebcbf8d84c0.svg";
export { ForwardRef as ReactComponent };